import { useRef, useEffect } from "react";
import Chart from "chart.js";
import { Leg } from "./../../../types";
import { calculateProfit } from "./../../../calculations/calculateProfits";

function generateLabels(
  positions: Leg[],
  putBreakEven: number | undefined,
  callBreakEven: number | undefined
) {
  const labels = positions.map((value: Leg) => value.strikePrice).sort();
  const sortedPositions = positions.sort(
    (a, b) => a.strikePrice - b.strikePrice
  );
  labels.splice(0, 0, Math.max(labels[0] - sortedPositions[0].price, 0));
  labels.push(
    parseInt(labels[labels.length - 1].toString()) +
      sortedPositions[sortedPositions.length - 1].price
  );

  if (putBreakEven && putBreakEven < labels[0]) {
    labels.splice(0, 0, putBreakEven);
  }

  if (callBreakEven && callBreakEven < labels[0]) {
    labels.splice(0, 0, callBreakEven);
  }

  if (callBreakEven && callBreakEven > labels[labels.length - 1]) {
    labels.push(callBreakEven);
  }

  if (putBreakEven && putBreakEven > labels[labels.length - 1]) {
    labels.push(putBreakEven);
  }

  if (labels.length < 4) {
    labels.splice(0, 0, Math.max(labels[0] - sortedPositions[0].price, 0));
    labels.push(
      parseInt(labels[labels.length - 1].toString()) +
        sortedPositions[sortedPositions.length - 1].price
    );
  }
  return labels;
}

export default function PayOffGraph(props: any) {
  const { width, height, strategy } = props;
  const chartRef = useRef<HTMLCanvasElement>(null);
  const labels = generateLabels(
    strategy.legs,
    strategy.putBreakEven,
    strategy.callBreakEven
  );
  const dataset = labels.map((value: number) => {
    return { x: value, y: 0 };
  });
  
  useEffect(() => {
    if (chartRef && chartRef.current) {
      // if ((window as any).chart !== undefined) {
      //   (window as any).chart.destroy();
      // }
      const ctx = chartRef.current;
      const chartOptions = {
        type: "line",
        tooltips: {
          mode: "nearest",
          intersect: false,
          displayColors: false,
        },
        interaction: {
          mode: "nearest",
          intersect: false,
        },
    
        data: {
          //labels: labels,
          datasets: [
            {
              label: "P/L", // Name the series
              data: dataset, // Specify the data values array
              fill: true,
              borderColor: "rgb(26, 194, 54)", // Add custom color border (Line)
              backgroundColor: "rgba(26, 194, 54, 0.3)", // Add custom color background (Points and Fill)
              borderWidth: 1, // Specify bar border width
              lineTension: 0,
              pointHitRadius: 10,
            },
          ],
        },
        options: {
          legend: { display: false },
          tooltips: {
            callbacks: {
              custom: function (tooltip: any) {
                if (!tooltip) return;
                // disable displaying the color box;
                tooltip.displayColors = false;
              },
              displayColors: false,
              label: function (tooltipItem: any) {
                  const text = tooltipItem.value > 0 ? "Profit" : "Loss"
                return text + " : " + Math.round(tooltipItem.value);
              },
              title: () => {
                return;
              },
            },
          },
          scales: {
            xAxes: [
              {
                type: "linear",
                position: "bottom",
              },
            ],
            yAxes: [
              {
                ticks: {
                  callback: function (label: any) {
                    return Math.abs(label) >= 1000 ? label / 1000 + " k" : label;
                  },
                },
                scaleLabel: {
                  display: false,
                  labelString: "1k = 1000",
                },
              },
            ],
          },
          responsive: true, // Instruct chart js to respond nicely.
          maintainAspectRatio: false, // Add to prevent default behaviour of full-width/height
        },
      };
      const chart: any = new Chart(ctx, chartOptions as any);
      setTimeout(() => {
        const newLabels = chart.scales["x-axis-0"]
          .ticksAsNumbers;
        const minLabel = newLabels[0];
        const maxLabel = newLabels[newLabels.length - 1];
        const diff = (maxLabel - minLabel)/((newLabels.length - 1) * 2);
        const newData = [];
        for(let i=minLabel; i<= maxLabel; i+= diff) {
          newData.push({
            x: i,
            y: calculateProfit(strategy.legs, i)
          })
        }
        chart.data.datasets[0].data = newData;
        chart.update();
      }, 200);
    }
  }, [width, height]);
  return (
    <div
      style={{ marginTop: "10px", marginBottom: "10px" }}
      className="e-field"
    >
      <canvas
        ref={chartRef}
        style={{ width: "100%", minHeight: "220px", maxHeight: "250px" }}
      ></canvas>
    </div>
  );
}
